module.exports = __webpack_public_path__ + "static/media/perspectives-cream.c83e7eda.svg";